import { FormControl, FormGroup } from '@angular/forms';

export type PForm = FormGroup<{ id: FormControl<string> }>;

export class PageForm {
  form = new FormGroup({
    id: new FormControl()
  });

  constructor(pageId: string) {
    this.form.get('id').setValue(pageId);
  }
}
